import { request } from '../utils/request'
import { urlStringify } from '../utils/index'

export default {
  getportalpages: option => request('v1/wxappportal/getportalpages', option, true, false), // 页面list
  deleteportalpage: option => {
    return request('v1/wxappportal/deleteportalpage' + urlStringify(option), {}, true, false) // 删除页面
  },
  publishhomepage: option => {
    return request('v1/wxappportal/publishhomepage' + urlStringify(option), {}, true, false) // 设为主页
  },
  publishportalpage: option => {
    return request('v1/wxappportal/publishportalpage' + urlStringify(option), {}, true, false) // 发布页面
  },
  getportalpage: option => {
    return request('v1/wxappportal/getportalpage' + urlStringify(option), {}, true, false) // 获取单个页面
  },
  addportalpage: option => request('v1/wxappportal/addportalpage', option, true, false), // 新增主页模版
  updateportalpage: option => request('v1/wxappportal/updateportalpage', option, true, false), // 修改主页模版
  gettagscanscenes: option => request('/v1/tagscanscene/gettagscanscenes', option, true, false), // 页面list
  gettagscanscene: option => {
    return request('/v1/tagscanscene/gettagscanscene' + urlStringify(option), {}, true, false) // 获取单个页面
  },
  addtagscanscene: option => request('v1/tagscanscene/addtagscanscene', option, true, false), // 新增主页模版
  updatetagscanscene: option => request('v1/tagscanscene/updatetagscanscene', option, true, false), // 修改主页模版
  settagscansceneproducts: option => request('v1/tagscanscene/settagscansceneproducts', option, true, false) // 新增主页模版
}
